export default __webpack_public_path__ + "static/media/icon-bolt.d7dad61c.svg";